import { sessionPrewarm } from './sessionPrewarm';

// Imported first from main.tsx so the refresh request leaves before the rest of
// the app (i18n, providers) has even been evaluated.
sessionPrewarm.start();
